import { gql } from '@apollo/client';

export default gql`
  mutation updateSuggestion(
    $_id: String
    $title: String
    $desc: String
    $category: String
    $priority: String
    $status: String
    $response: String
    $responseDate: Date
    $responseBy: String
    $employeeId: String
    $employeeName: String
    $employeeNameAr: String
    $departmentId: String
    $attachments: [AttachmentInput]
  ) {
    updateSuggestion(
      _id: $_id
      title: $title
      desc: $desc
      category: $category
      priority: $priority
      status: $status
      response: $response
      responseDate: $responseDate
      responseBy: $responseBy
      employeeId: $employeeId
      employeeName: $employeeName
      employeeNameAr: $employeeNameAr
      departmentId: $departmentId
      attachments: $attachments
    ) {
      ok
      error
      data
    }
  }
`;
